import axios from "axios";

export const state = {
    requisitions: [],
};

export const getters = {
    stores: state => state.requisitions,
};

export const mutations = {
    setRequisitions(state, newValue) {
        state.Requisitions = newValue
    },
};

export const actions = {
    fetchRequisitions({ commit }) {
        axios.get('/orders').then(res => {
            commit('setRequisitions', res.data.requisitions)
        })
    },
};
